<template>
  <div class="about">
    <h1>This is an about page - Change 3</h1>
  </div>
</template>
